<template>
    <div>
        <ad-leaderboard />
        <div v-if="userBanned">
            {{ $t('publicProfile.userBanned') }}
        </div>
        <ion-grid v-else>
            <ion-row>
                <ion-col size-xs="12" size-md="12" size-xl="4"
                    ><div class="top-profile-wrapper" lines="none">
                        <div v-if="windowWidth < 1200" class="top-background"></div>
                        <div class="profile-pic-wrapper ion-margin-top">
                            <div class="profile-picture">
                                <img ref="displayedPicture" :src="profilePictures[0] || require('@/assets/imgupload.png')" />
                            </div>
                            <div class="avatars-wrapper">
                                <ion-list>
                                    <ion-avatar
                                        v-for="(profilePic, index) in profilePictures"
                                        :key="index"
                                        :class="index == 0 ? 'selected-picture' : ''"
                                    >
                                        <img :src="profilePic" @click="changeDisplayedPicture" />
                                    </ion-avatar>
                                </ion-list>
                            </div>
                        </div>
                        <ion-button v-if="!sameGender && isLiked == null" class="btn-like" @click="likeUser(user)">
                            {{ $t('master.like') }}
                        </ion-button>
                        <span v-else-if="!sameGender && isLiked != null && isLiked != 'rejected'" class="like-status">
                            {{ likeStatus }}
                        </span>
                    </div></ion-col
                >
                <ion-col size-xs="12" size-md="12" size-xl="8"
                    ><ion-grid style="padding-top:0px;">
                        <div>
                            <ion-row v-if="likeRequest">
                                <ion-col size="12"> {{ $t('publicProfile.likeRequest', { username }) }}</ion-col>
                                <ion-col size="12">
                                    <ion-button color="primary" @click="respondToLike('accepted')">{{
                                        $t('publicProfile.accept')
                                    }}</ion-button>
                                    <ion-button color="danger" @click="respondToLike('rejected')">{{
                                        $t('publicProfile.reject')
                                    }}</ion-button>
                                </ion-col>
                            </ion-row>
                            <ion-row v-if="likeResponse">
                                <ion-col v-if="likeResponse == 'accepted'" size="12">
                                    <img src="@/assets/icon-images/tick.png" class="icon-img-xs" />
                                    {{ $t('publicProfile.likeAccept', { username }) }}
                                </ion-col>
                                <ion-col v-else size="12">
                                    <img src="@/assets/icon-images/cancel.png" class="icon-img-xs" />
                                    {{ $t('publicProfile.likeReject', { username }) }}
                                </ion-col>
                            </ion-row>
                            <div class="w-100 username-wrapper">
                                <h5 class="w-100 ion-text-start username">
                                    {{ username }}
                                    <div v-if="!!isOnline" class="tooltip online-status">
                                        <span class="tooltiptext">{{ $t('home.online') }}</span>
                                    </div>
                                    <img :src="genderIcon" class="ion-float-end gender-icon icon-img-xs" />
                                </h5>
                                <p v-if="!isOnline" class="w-100 ion-text-start offline-status">
                                    {{ `${$t('publicProfile.lastOnline')}${lastActive}` }}
                                </p>
                            </div>
                            <div class="contact-ways-logos ion-padding-start ion-text-start">
                                <img
                                    v-if="hasWhatsapp"
                                    class="icon-img-xs"
                                    @click="showDetails('whatsapp')"
                                    src="@/assets/icon-images/whatsapp.png"
                                />
                                <img
                                    v-if="hasEmail"
                                    class="icon-img-xs"
                                    @click="showDetails('email')"
                                    src="@/assets/icon-images/email.png"
                                />
                                <img
                                    v-if="hasFacebook"
                                    class="icon-img-xs"
                                    @click="showDetails('facebook')"
                                    src="@/assets/icon-images/facebook.png"
                                />
                                <img
                                    v-if="hasInstagram"
                                    class="icon-img-xs"
                                    @click="showDetails('instagram')"
                                    src="@/assets/icon-images/instagram.png"
                                />
                            </div>
                        </div>
                        <ion-row>
                            <ion-col size-xs="6" size-sm="6" size-md="4">
                                <user-option :label="$t('options.maritalStatus')" :option="userMaritalStatus" />
                            </ion-col>
                            <ion-col size-xs="6" size-sm="6" size-md="4">
                                <user-option :label="$t('options.kids')" :option="userKids" />
                            </ion-col>
                            <ion-col size-xs="6" size-sm="6" size-md="4">
                                <user-option :label="$t('options.purpose')" :option="userPurpose" />
                            </ion-col>
                            <ion-col size-xs="6" size-sm="6" size-md="3">
                                <user-option :label="$t('options.age')" :option="userAge" />
                            </ion-col>
                            <ion-col class="no-padding-right" size-xs="4" size-sm="4" size-md="3">
                                <user-option :label="$t('options.eyeColor')" :option="userEyeColor" />
                            </ion-col>
                            <ion-col class="no-padding-right no-padding-left" size-xs="4" size-sm="4" size-md="3">
                                <user-option :label="$t('options.hairColor')" :option="userHairColor" />
                            </ion-col>
                            <ion-col class="no-padding-left" size-xs="4" size-sm="4" size-md="3">
                                <user-option :label="$t('options.skinColor')" :option="userSkinColor" />
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col size="12">
                                <user-option :label="$t('publicProfile.describeSelf')" :option="userDescribeSelf" />
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col size="12">
                                <user-option :label="$t('publicProfile.describeOthers')" :option="userDescribeOthers" />
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size-xs="6" size-sm="6" size-md="4">
                                <user-option :label="$t('options.height')" :option="userHeight" />
                            </ion-col>
                            <ion-col size-xs="6" size-sm="6" size-md="4">
                                <user-option :label="$t('options.weight')" :option="userWeight" />
                            </ion-col>

                            <ion-col size-xs="6" size-sm="6" size-md="4">
                                <user-option :label="$t('options.educationalLevel')" :option="userEducation" />
                            </ion-col>
                            <ion-col size-xs="6" size-sm="6" size-md="4">
                                <user-option :label="$t('options.job')" :option="userJob" />
                            </ion-col>

                            <ion-col size-xs="6" size-sm="6" size-md="4">
                                <user-option :label="$t('options.country')" :option="userCountry" />
                            </ion-col>
                            <ion-col size-xs="6" size-sm="6" size-md="4">
                                <user-option :label="$t('options.originCountry')" :option="userOriginCountry" />
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col size="12">
                                <ion-button v-if="!sameGender" class="btn-start-chat ion-float-start" @click="startChat">{{
                                    $t('publicProfile.startChat')
                                }}</ion-button>
                                <ion-button
                                    @click="isBlocked ? unblockUser() : blockUser()"
                                    class="btn-block ion-float-end"
                                    color="light"
                                    >{{ isBlocked ? $t('master.unblock') : $t('master.block') }}</ion-button
                                >
                                <ion-button v-if="!isReported" @click="reportUser()" class="btn-block ion-float-end" color="light">{{
                                    $t('master.report')
                                }}</ion-button>
                            </ion-col>
                        </ion-row>
                    </ion-grid></ion-col
                >
            </ion-row>
        </ion-grid>
    </div>
</template>

<script>
import UserOption from '@/components/UserOption'
import AdLeaderboard from '@/components/AdLeaderboard'
import AxiosController from '@/controllers/AxiosController'
import { mapGetters } from 'vuex'
import { isTablet } from 'mobile-device-detect'
import { constants } from '../../constants'

export default {
    name: 'PublicProfile',
    components: { UserOption, AdLeaderboard },
    data() {
        return {
            username: '',
            profilePictures: [],
            options: [],
            userEyeColor: '',
            userHairColor: '',
            userSkinColor: '',
            userGender: '',
            userKids: '',
            userPurpose: '',
            userCountry: '',
            userMaritalStatus: '',
            userWeight: '',
            userHeight: '',
            userEducation: '',
            userJob: '',
            userAge: '',
            userOriginCountry: '',
            userDescribeSelf: '',
            userDescribeOthers: '',
            isBlocked: false,
            isReported: false,
            isLiked: '',
            sameGender: '',
            isTablet: isTablet,
            likeStatus: '',
            likeRequest: 0,
            likeResponse: '',
            genderIcon: '',
            contactWays: [],
            hasWhatsapp: false,
            hasEmail: false,
            hasFacebook: false,
            hasInstagram: false,
            constants,
            userBanned: false,
            isOnline: '',
            lastActive: ''
        }
    },
    computed: mapGetters(['user']),
    mounted() {
        const userId = this.$route.params.id
        const url = `/users/${userId}`
        const params = { current_user_id: this.user ? this.user.id : null }

        AxiosController.get(url, { params }).then(res => {
            if (res.data == 'banned') {
                this.userBanned = true
                return
            }
            const user = res.data.user
            if (this.user) {
                if (res.data.blockedByUser) {
                    this.$router.push('/blocked')
                    return
                } else {
                    if (this.user.id != userId) {
                        const viewData = { to: userId }
                        AxiosController.post('/view', viewData)
                    }

                    this.isLiked = res.data.is_liked

                    if (this.isLiked == 'requested')
                        this.likeStatus = this.$t('publicProfile.likeRequested', {
                            username: user.name
                        })
                    else if (this.isLiked == 'accepted')
                        this.likeStatus = this.$t('publicProfile.likeAccepted', {
                            username: user.name
                        })
                    this.isBlocked = !!res.data.is_blocked
                    this.likeRequest = res.data.like_requested
                }
            }

            this.options = user.options
            this.userEyeColor = this.options.filter(({ type }) => type === 'eye-color')[0]
            this.userHairColor = this.options.filter(({ type }) => type === 'hair-color')[0]
            this.userSkinColor = this.options.filter(({ type }) => type === 'skin-color')[0]
            this.userGender = this.options.filter(({ type }) => type === 'gender')[0]
            this.userKids = this.options.filter(({ type }) => type === 'kids')[0]
            this.userPurpose = this.options.filter(({ type }) => type === 'purpose')[0]
            this.userCountry = this.options.filter(({ type }) => type === 'country')[0]
            this.userOriginCountry = this.options.filter(({ type }) => type === 'origin-country')[0]
            this.userMaritalStatus = this.options.filter(({ type }) => type === 'marital-status')[0]
            this.userHeight = this.options.filter(({ type }) => type === 'height')[0]
            this.userWeight = this.options.filter(({ type }) => type === 'weight')[0]
            this.userEducation = this.options.filter(({ type }) => type === 'educational-level')[0]
            this.userJob = this.options.filter(({ type }) => type === 'job')[0]
            this.userAge = this.options.filter(({ type }) => type === 'age')[0]
            this.userDescribeSelf = this.options.filter(({ type }) => type === 'describe-yourself')[0]
            this.userDescribeOthers = this.options.filter(({ type }) => type === 'describe-others')[0]
            this.options.filter(({ type }) => type === 'contact-ways').forEach(way => this.contactWays.push(way.value))
            this.hasWhatsapp = !!this.contactWays.find(val => val === 'whatsapp')
            this.hasInstagram = !!this.contactWays.find(val => val === 'instagram')
            this.hasEmail = !!this.contactWays.find(val => val === 'email')
            this.hasFacebook = !!this.contactWays.find(val => val === 'facebook')

            this.genderIcon =
                this.userGender.value == 'male' ? require('@/assets/icon-images/male.png') : require('@/assets/icon-images/female.png')

            this.username = user.name
            this.lastActive = user.last_active
            this.isOnline = user.is_online
            if (user.approved_images) {
                user.approved_images.forEach((i, index) => {
                    this.profilePictures[index] = [`${constants.assetsUri}/${i.path}`]
                })
            }
            if (this.user) {
                this.sameGender = this.userGender.id == this.user.options.find(option => option.type === 'gender').id ? true : false
            }
        })
    },
    methods: {
        changeDisplayedPicture: function(e) {
            this.$refs.displayedPicture.src = e.target.src
            var childrenArray = [...e.target.parentElement.parentElement.children]
            childrenArray.forEach(div => {
                div.classList.remove('selected-picture')
            })
            e.target.parentElement.classList.add('selected-picture')
        },
        likeUser: function(currentUser) {
            if (currentUser && currentUser.has_access && !currentUser.approved) {
                const message = this.$t('master.unapprovedUser')
                return this.$ionic.alertController
                    .create({
                        subHeader: message,
                        buttons: ['OK']
                    })
                    .then(a => a.present())
            } else if (currentUser) {
                const userId = this.$route.params.id
                const data = {
                    to: userId
                }
                AxiosController.post('/like', data)
                    .then(res => {
                        this.isLiked = res.data.status
                        this.likeStatus = this.$t('publicProfile.likeRequested', {
                            username: this.username
                        })
                    })
                    .catch(err => console.log(err))
            } else {
                this.redirectToLogin()
            }
        },
        startChat: function() {
            if (this.user && this.user.has_access) {
                const userId = this.$route.params.id
                this.$router.push('/messages?id=' + userId)
            } else if (this.user) {
                this.$router.push('/plans')
            } else {
                this.redirectToLogin()
            }
        },
        blockUser: function() {
            if (!this.user) {
                this.redirectToLogin()
                return
            }

            const userId = this.$route.params.id
            AxiosController.post('/block', { userId })
                .then((this.isBlocked = true))
                .catch(err => console.log(err))
        },
        reportUser: function() {
            if (!this.user) {
                this.redirectToLogin()
                return
            }

            const userId = this.$route.params.id
            AxiosController.post('/report', { userId })
                .then((this.isReported = true))
                .catch(err => console.log(err))
        },
        unblockUser: function() {
            if (!this.user) {
                this.redirectToLogin()
                return
            }

            const userId = this.$route.params.id
            AxiosController.post('/unblock', { userId })
                .then((this.isBlocked = false))
                .catch(err => console.log(err))
        },
        respondToLike: function(response) {
            const userId = this.$route.params.id
            const data = {
                from: userId,
                response: response
            }
            AxiosController.post('/respond-like', data).then(() => {
                this.likeRequest = false
                this.likeResponse = response
            })
        },
        showDetails(contactWay) {
            if (this.userGender.value == 'female') {
                const value = this.options.find(option => option.value === contactWay).pivot.details
                const translatedContactWay = this.$t('publicProfile.' + contactWay)
                if (this.user && this.user.has_access) {
                    return this.$ionic.alertController
                        .create({
                            header: translatedContactWay,
                            subHeader: value,
                            buttons: ['OK']
                        })
                        .then(a => a.present())
                } else {
                    const subscribeForDetails = this.$t('publicProfile.subscribeForDetails')
                    return this.$ionic.alertController
                        .create({
                            header: subscribeForDetails,
                            buttons: ['OK']
                        })
                        .then(a => a.present())
                }
            }
        },
        redirectToLogin() {
            this.windowWidth < 1200 ? this.$router.push('/login') : this.$router.push('/')
        }
    }
}
</script>

<style lang="scss" scoped>
.top-profile-wrapper {
    position: relative;
    top: -15px;

    .btn-like {
        position: absolute;
        right: 0;
        bottom: 0;
        margin-right: 5px;
        padding: 10px 0 0 0;
    }
}
.profile-pic-wrapper {
    padding-top: 25px;
    width: 50%;
    z-index: 1;
    margin: 30px auto 0 auto;
    position: relative;

    .avatars-wrapper {
        position: absolute;
        left: -15px;
        top: 0;
        height: 100%;

        ion-list {
            background: transparent;
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 100%;

            ion-avatar {
                margin: 1px auto;
                --border-radius: 50%;
                border: 2px solid white;
                height: 35px;
                width: 35px;
            }

            .selected-picture {
                border: 2px solid green;
            }
        }
    }
}

.top-background {
    position: absolute;
    top: 0;
    height: 100px;
    width: 95%;
    background: url('~@/assets/chat-bg.jpg');
    z-index: 0;
    left: 2.5%;
}
.offline-status {
    padding: 0 5%;
    margin-top: 10px;
    margin-bottom: 10px;
    color: #114f64;
    font-size: 18px;
}
.username {
    padding: 0 5%;
    margin-top: 2px;
    margin-bottom: 2px;
    color: #114f64;
    font-weight: 700;

    .gender-icon {
        font-size: 25px;
        color: #000000;
    }
}

.contact-ways-logos {
    img {
        margin-right: 7px;
        opacity: 0.6;
    }
}

.no-padding-left {
    padding-left: 0;
}

.no-padding-right {
    padding-right: 0;
}

ion-button {
    --border-radius: 20px;
}

.online-status {
    width: 15px;
    height: 15px;
    border-radius: 100%;
    background-color: #00ec27;
    position: relative;
    display: inline-block;
}

.tooltip .tooltiptext {
    visibility: hidden;
    width: 90px;
    background-color: #244a55;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    font-size: 12px;

    /* Position the tooltip */
    position: absolute;
    top: -5px;
    z-index: 1;
}

.tooltip:hover .tooltiptext {
    visibility: visible;
}

@media (min-width: 768px) {
    .username-wrapper {
        width: 60%;

        .username {
            font-size: 24px;
            padding-left: 14px;
        }
    }

    .top-background {
        width: 95%;
        left: 2.5%;
        height: 20vh;
    }

    .profile-pic-wrapper {
        width: 30%;
        left: 26%;

        .avatars-wrapper {
            left: -18px;

            ion-avatar {
                height: 45px !important;
                width: 45px !important;
            }
        }
    }

    .btn-start-chat,
    .btn-like,
    .btn-block {
        font-size: 12px;
        --border-radius: 40px !important;
    }

    .btn-like {
        left: 40%;
        width: 120px;
    }

    .btn-back {
        position: absolute;
        left: 2.5%;
        bottom: 0;
        font-size: 16px;
    }

    .btn-block {
        font-size: 12px;
        margin-right: 10px;
    }

    .btn-start-chat {
        margin-left: 10px;
    }
}

@media (min-width: 1200px) {
    .profile-pic-wrapper {
        width: 100% !important;
        left: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        margin-top: 10px !important;
    }
    ion-col {
        padding: 5px 0 !important;
    }
    .profile-picture img {
        width: 100%;
    }

    .btn-like {
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        width: 120px;
    }
}
</style>
